import React, { useEffect, useState } from 'react';

import CardUi from '../components/common/Card';
import {Divider} from "antd";

const Selection: React.FC = () => {
  const [items, setItems] = useState([
    'Selection overview by airport',
    'Selection overview by Destination country',
    'Selection overview by Destination city',
  ]);

  const items2 = [
    '1 × 1 detailed selection comparison by Airport',
    '1 × 1 detailed selection comparison by Destination country',
    '1 × 1 detailed selection comparison by Destination city',
  ];

  const items3 = [
    'Unmet flights by Airport',
    'Unmet flights by Destination country',
    'Unmet flights by Destination city',
  ];

  useEffect(() => {
  }, []);

  return (
      <>
      <Divider style={{marginBottom:0}}>
        <h3 style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(3 55 120)', letterSpacing: '0.5px' }}>Selection analysis</h3>
      </Divider>
    <div
      style={{
        margin: '60px auto',
        display: 'flex',
        gap: '3rem',
        flexDirection: 'column',
      }}
    >
      <div>
        <CardUi
          items={items}
          title="High level overview of my selection vs. competitors"
        />
      </div>
      <div>
        <CardUi
          items={items2}
          title="Flight-by-flight selection comparison, sliced by competitor"
        />
      </div>
      <div>
        <CardUi
          items={items3}
          title="High level overview of the non-common flights reports"
        />
      </div>
    </div>
        </>
  );
};

export default Selection;
